import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { ChangeStatusService } from './../../services/change-status.service';
import { SecondHandSuppliesOrders } from './../../models/second-hand-supplies-orders';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss']
})
export class ChangeStatusComponent implements OnInit {
  /* --------------------------- change status form --------------------------- */

  selectTab: any;
  changeStatusForm = this.fb.group({
    status: [null, [Validators.required]],
    message: [null, []],
    extra: this.fb.group({
      type: ['IMAGE', [Validators.required]],
      invoice: [null, []],
      tracking_number: [null, []],
      tracking_link: [null, []],
      freight_company_name: [null, []]
    })
  });
  orderNotes: any[];
  allowedImageTypes = ['png', 'jpg', 'jpeg'];
  allowedFileTypes = ['pdf', 'doc', 'docx'];
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<ChangeStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSuppliesOrders,
    private changeStatusService: ChangeStatusService,
    private toast: ToastService,
    private spinner: NgxSpinnerService
  ) { }
/* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
    console.log(this.data.second_hand_supplies_order_notes)
    this.orderNotes = this.data.second_hand_supplies_order_notes;
    this.status.valueChanges.subscribe(status=>{
      if(status === 'SHIPPED'){
        this.extra.enable();
        this.invoice.setValidators([Validators.required]);
        this.tracking_number.setValidators([Validators.required]);
        this.tracking_link.setValidators([Validators.required]);
        this.freight_company_name.setValidators([Validators.required]);
      } else {
        this.extra.disable();
        this.invoice.setValidators([]);
        this.tracking_number.setValidators([]);
        this.tracking_link.setValidators([]);
        this.freight_company_name.setValidators([]);
      }
    });
  }

  /* ---------------------------- Custom Functions ---------------------------- */
  dialogClose(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */
  get status(){
    return this.changeStatusForm.get('status');
  }
  get message(){
    return this.changeStatusForm.get('message');
  }
  get extra(): FormGroup {
    return this.changeStatusForm.get('extra') as FormGroup;
  }
  get type(){
    return this.extra.get('type');
  }
  get invoice(){
    return this.extra.get('invoice');
  }
  get tracking_number(){
    return this.extra.get('tracking_number');
  }
  get tracking_link(){
    return this.extra.get('tracking_link');
  }
  get freight_company_name(){
    return this.extra.get('freight_company_name');
  }

  async updateStatus(){
    
    if(this.status.value == null){
 
      this.toast.openSnackBar('Please Select Status');
      this.selectTab = 'null';
    }
    else{

      if(this.changeStatusForm.invalid){
        this.toast.openSnackBar('Please enter valid details');
        return;
      }
      this.spinner.show();
      try {
        await this.changeStatusService.changeStatus(
          this.data.id, {
            status: this.status.value
          } , {
            second_hand_supplies_order_id : this.data.id,
            status: this.status.value,
            message: this.message.value,
            extra: this.extra.value
          });
          this.spinner.hide();
          this.toast.openSnackBar('Status updated successfully');
          this.dialogClose('yes');
      } catch(error) {
        this.spinner.hide();
         this.toast.openSnackBar('Unable to update status');
      }

    }
   
  }

  trimMe(ac: AbstractControl){
    ac.setValue(ac.value.trim());
  }
}
